<template>
  <app-modal
    ref="modal"
    v-bind="$attrs"
    class="modal-container"
    content-class="modal-medium"
    title="確認"
  >
    <template v-slot:body="{ cancel }">
      <!-- BODY -->
      <v-card-text class="pa-0">
        <div class="modal-body pa-4">
          <div class="font-weight-bold mb-3">
            アプライアンスのオプションを設定します。よろしいですか？
          </div>
          <v-row>
            <v-col cols="12">
              <app-label-group
                label="対象V番号"
                :value="user.contractInfo.vnumber"
              />
            </v-col>
          </v-row>
          <template v-if="contractOption.additionalLogCapacity !== null">
            <v-row>
              <v-col cols="12">
                <app-label-group label="追加ログ保存容量">
                  <template #value>
                    <template v-if="additionalLog === 'ON'">
                      <div>
                        <span class="ml-3">
                          {{
                            `現在ログ保存容量設定 ${
                              contractOption.additionalLogCapacity! + 10
                            }GB`
                          }}
                        </span>
                      </div>
                    </template>
                    <div>
                      <span class="ml-3">
                        <template v-if="additionalLog === 'ON'">
                          {{ `ON ${contractOption.additionalLogCapacity}GB` }}
                        </template>
                        <template v-else> OFF </template>
                      </span>
                    </div>
                  </template>
                </app-label-group>
              </v-col>
            </v-row>
          </template>
          <template v-if="contractOption.isAllowLog !== null">
            <v-row>
              <v-col cols="12">
                <app-label-group
                  label="Allowログ"
                  :value="$filter.enumTo(contractOption.isAllowLog, 'on_off')"
                />
              </v-col>
            </v-row>
          </template>
          <template v-if="contractOption.isStatistics !== null">
            <v-row>
              <v-col cols="12">
                <app-label-group
                  label="統計情報レポート"
                  :value="$filter.enumTo(contractOption.isStatistics, 'on_off')"
                />
              </v-col>
            </v-row>
          </template>
        </div>
      </v-card-text>
      <v-divider></v-divider>
      <!-- FOOTER -->
      <v-card-actions>
        <v-list-item class="w-100 pa-1">
          <template v-slot:append>
            <v-btn variant="flat" color="primary" @click="submit">はい</v-btn>
            <v-btn variant="outlined" color="primary" @click="cancel"
              >いいえ
            </v-btn>
          </template>
        </v-list-item>
      </v-card-actions>
    </template>
  </app-modal>
</template>

<script lang="ts">
import type { PropType } from "vue";
import { defineComponent } from "vue";
import type { ContractChangeOption } from "@/apis/ContractChangeOptionApi";
import { VueFinalModal } from "vue-final-modal";

export default defineComponent({
  name: "ContractOptionConfirm",
  props: {
    contractOption: {
      type: Object as PropType<ContractChangeOption>,
      required: true,
    },
    additionalLog: {
      type: String as PropType<string>,
      required: true,
    },
  },
  data() {
    return {
      /** ユーザ設定 */
      user: this.$store.state.user,
    };
  },
  methods: {
    /** 「はい」選択時の挙動 */
    submit() {
      (this.$refs.modal as typeof VueFinalModal & { ok: () => void }).ok();
    },
  },
});
</script>
